/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_3_SolutionInputs */

const et_portfolio_project_3_solution = /** @type {(inputs: Portfolio_Project_3_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kujundasime ümber konversioonile, lihtsustasime ostuprotsessi ja rakendasime sihitud kliendihanke strateegia.`)
};

const en_portfolio_project_3_solution = /** @type {(inputs: Portfolio_Project_3_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redesigned for conversions, simplified buying flow, and implemented a targeted acquisition strategy.`)
};

/**
* | output |
* | --- |
* | "Redesigned for conversions, simplified buying flow, and implemented a targeted acquisition strategy." |
*
* @param {Portfolio_Project_3_SolutionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_3_solution = /** @type {((inputs?: Portfolio_Project_3_SolutionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_3_SolutionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_3_solution(inputs)
	return en_portfolio_project_3_solution(inputs)
});